import { designToken, quickProperty } from '../component-tokens';
import { borderBase, focusState } from './common';
export const navDrawerData = {
    tag: 'chameleon-nav-drawer',
    name: 'nav-drawer',
    reactImports: 'NavigationDrawer, NavigationDrawerItem, NavigationDrawerHeader, NavigationDrawerSection',
    attributes: {
        width: quickProperty('256px'),
        'background-color': designToken('ui-base-01'),
        'padding-top': designToken('spacing-06'),
        display: quickProperty('inline-flex'),
        'flex-direction': quickProperty('column'),
    },
    children: [
        {
            name: 'header',
            attributes: {
                padding: quickProperty('0 var(--goto-spacing-04)'),
                'margin-bottom': designToken('spacing-04'),
            },
        },
        {
            name: 'subheader',
            attributes: {
                padding: quickProperty('20px 16px 8px'),
                'align-items': quickProperty('center'),
                display: quickProperty('inline-flex'),
                outline: quickProperty('0'),
            },
        },
        {
            name: 'item',
            attributes: Object.assign(Object.assign({}, borderBase), { outline: quickProperty('0'), cursor: quickProperty('pointer'), 'border-color': quickProperty('transparent'), display: quickProperty('inline-flex'), 'align-items': quickProperty('center'), height: quickProperty('36px'), padding: quickProperty('0 var(--goto-spacing-05)'), 'box-sizing': quickProperty('border-box') }),
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-secondary'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-secondary'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, focusState),
                },
                {
                    name: 'selected',
                    attributes: {
                        'background-color': designToken('nav-drawer-item-background-selected'),
                    },
                },
                {
                    name: 'disabled',
                    attributes: {
                        'background-color': quickProperty('transparent'),
                    },
                },
            ],
            children: [
                {
                    name: 'content',
                    attributes: {
                        font: designToken('body-small'),
                        color: designToken('text-01'),
                        display: quickProperty('block'),
                        flex: quickProperty('1'),
                        'white-space': quickProperty('nowrap'),
                        overflow: quickProperty('hidden'),
                        'text-overflow': quickProperty('ellipsis'),
                    },
                },
                {
                    name: 'selected-content',
                    attributes: {
                        color: designToken('text-04'),
                        '--goto-icon-color': designToken('text-04'),
                    },
                },
                {
                    name: 'disabled-content',
                    attributes: {
                        color: designToken('disabled-03'),
                        '--goto-icon-color': designToken('disabled-03'),
                    },
                },
            ],
        },
    ],
    sizes: [
        {
            name: 'small',
            children: [
                {
                    name: 'item',
                    attributes: {
                        height: designToken('spacing-06'),
                    },
                },
                {
                    name: 'content',
                    attributes: {
                        font: designToken('caption-default-01'),
                    },
                },
            ],
        },
        {
            name: 'large',
            children: [
                {
                    name: 'item',
                    attributes: {
                        height: quickProperty('44px'),
                        margin: quickProperty('0.25rem 0.5rem'),
                        'border-radius': quickProperty('4px'),
                        padding: quickProperty('0 12px'),
                    },
                },
                {
                    name: 'content',
                    attributes: {
                        font: designToken('body-medium'),
                    },
                },
            ],
        },
    ],
};
